/**
 * The grouping and date-formatting /evenimente and /instruiri both need to show a flat,
 * date-ordered list as a calendar split into months.
 *
 * Lifted out of EventRoutes.tsx, which is where it was written first, so /instruiri can render the
 * same month-grouped card layout over its own fields rather than carrying a second copy of this —
 * the two pages already disagreed on nothing here, they just hadn't been asked to share it yet.
 */

/** Groups a flat list into months, in the order the API returns (both endpoints answer sorted). */
export function groupByMonth<T extends { startsAt: string }>(items: T[]): [string, T[]][] {
  const groups = new Map<string, T[]>();
  for (const item of items) {
    const d = new Date(item.startsAt);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const bucket = groups.get(key);
    if (bucket) bucket.push(item);
    else groups.set(key, [item]);
  }
  return [...groups.entries()];
}

/** The two locales these calendars format dates in — 'en' maps to en-GB, everything else to ro-RO. */
export function calendarLocale(language: string): string {
  return language === 'en' ? 'en-GB' : 'ro-RO';
}

/** "Septembrie 2026" from a "2026-09" grouping key — Intl hands back the month name lowercased. */
export function monthLabel(key: string, language: string): string {
  const [year, month] = key.split('-').map(Number);
  const label = new Date(year, month - 1, 1).toLocaleDateString(calendarLocale(language), {
    month: 'long',
    year: 'numeric',
  });
  return label.charAt(0).toUpperCase() + label.slice(1);
}
